// noinspection ES6ConvertVarToLetConst

var SystemMessagesCtrl = function ($scope) {
    'use strict';

    $scope.systemMessageRoleTypesList = [];
    $scope.isCandidateChecked = false;

    $scope.setSystemMessageRoleTypesList = function (systemMessageRoleTypesList) {
        $scope.systemMessageRoleTypesList = systemMessageRoleTypesList || [];
        $scope.isCandidateChecked = $scope.systemMessageRoleTypesList.includes(531);
    };

    $scope.onChange = function () {
        var selector = '#systemMessageRoleTypesId.multi-select input:checked';
        var nodes = document.querySelectorAll(selector);
        var systemMessageRoleTypesList = [];

        for (var i = 0; i < nodes.length; i++) {
            var node = nodes[i];
            systemMessageRoleTypesList.push(+node.value);
        }

        $scope.setSystemMessageRoleTypesList(systemMessageRoleTypesList);
    };

    return $scope; // controller as works
};

SystemMessagesCtrl.$inject = ['$scope'];
angular.module('app').controller('SystemMessagesCtrl', SystemMessagesCtrl);
